module.exports = __webpack_public_path__ + "static/Jeng-Oshiro2-113d1b1349bbfee5f9123bdd81709859.jpg";